/* Packages */
import React from 'react';
import { render } from 'react-dom';

/* utilities */
import { parseDataToProps } from '~/utilities';

const openingTimesNodes = Array.from(document.querySelectorAll('.opening-times-vdp'));
if (openingTimesNodes.length) {
    import(/* webpackChunkName: "OpeningTimes" */ './components/OpeningTimes').then(({ default: OpeningTimes }) => {
        openingTimesNodes.forEach((node) => render(<OpeningTimes {...parseDataToProps(node.dataset)}/>, node));
    });
}
